module.exports = __webpack_public_path__ + "static/img/goodmsg.9c13db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/goodmsg.png
// module id = 1223
// module chunks = 0